// extracted by mini-css-extract-plugin
export default {"addons":"ChangeProduct_addons__IddMT"};